;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"06bf00e7f373b6e736c3ab88a2357be29da70e4c"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/fem/06bf00e7f373b6e736c3ab88a2357be29da70e4c";import * as Sentry from '@sentry/nextjs'
import {getEnvironment, SENTRY_TRACES_SAMPLE_RATE} from 'sentry.utils'
import {env} from '~/config/env.mjs'
import {isProd} from '~/config/nodeEnv'

Sentry.init({
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  debug: false,
  enabled: isProd,
  environment: getEnvironment(),
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
})
